<section class="ecommerce-view-sidebar-wrapper">
  <div class="sidebar-items-wrapper">
    <div class="sidebar-item" *ngFor="let item of sidebar.items">
      <div class="sidebar-item-label">
        {{ item.label }}
      </div>
      <div class="sidebar-item-value" [ngClass]="{'red': item.label === 'Discount'}">
        {{ item.value }}
      </div>
    </div>
  </div>

  <div class="ecommerce-view-sidebar-order-info"
       *ngIf="!!sidebar?.hasRefunds?.value">
    <div class="ecommerce-view-sidebar-order-info-item">
      <div class="ecommerce-view-sidebar-order-info-item-label">
        {{ sidebar.orderTotal.label }}
      </div>
      <div class="ecommerce-view-sidebar-order-info-item-value">
        {{ sidebar.orderTotal.value }}
      </div>
    </div>

    <div class="ecommerce-view-sidebar-order-info-item">
      <div class="ecommerce-view-sidebar-order-info-item-label">
        {{ sidebar.paid.label }}
      </div>
      <div class="ecommerce-view-sidebar-order-info-item-value">
        {{ sidebar.paid.value }}
      </div>
    </div>
  </div>

  <div class="ecommerce-view-sidebar-footer">
    <div class="ecommerce-view-sidebar-footer-item refunded mb12"
         *ngIf="!!sidebar?.hasRefunds?.value">
      <div class="ecommerce-view-sidebar-footer-item-label">
        {{ sidebar.refunded.label }}
      </div>
      <div class="ecommerce-view-sidebar-footer-item-value">
        {{ sidebar.refunded.value }}
      </div>
    </div>

    <div class="ecommerce-view-sidebar-footer-item">
      <div class="ecommerce-view-sidebar-footer-item-label">
        {{ sidebar.footer.label }}
      </div>
      <div class="ecommerce-view-sidebar-footer-item-value">
        {{ sidebar.footer.value }}
      </div>
    </div>
  </div>

</section>
